import { motion } from "framer-motion";

export default function PolitiqueConfidentialitePage() {
  return (
    <div>
      <section className="relative py-24 overflow-hidden" data-testid="confidentialite-hero">
        <div className="absolute inset-0 bg-[#2C1E14]" />
        <div className="relative container-hh">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
            <h1 className="font-display text-4xl md:text-5xl text-white mb-4">Politique de confidentialité</h1>
            <p className="text-white/70 text-lg">Comment nous protégeons vos données personnelles.</p>
          </motion.div>
        </div>
      </section>

      <section className="section-hh bg-[#F5F0EB]" data-testid="confidentialite-content">
        <div className="container-hh max-w-3xl">
          <div className="bg-[#FFFDF9] p-8 md:p-12 rounded-xl shadow-[0_4px_24px_rgba(44,30,20,0.08)] border border-[#E0D6CA] space-y-8">
            <div>
              <h2 className="font-display text-xl text-[#004333] mb-3">Collecte des données</h2>
              <p className="text-[#6B5E50] leading-relaxed">
                Happyhouse conciergerie collecte des données personnelles uniquement lorsque vous remplissez un formulaire de contact, effectuez une demande d'estimation ou créez une réservation. Les données collectées peuvent inclure : nom, prénom, adresse email, numéro de téléphone et message.
              </p>
            </div>

            <div>
              <h2 className="font-display text-xl text-[#004333] mb-3">Utilisation des données</h2>
              <p className="text-[#6B5E50] leading-relaxed">
                Vos données personnelles sont utilisées exclusivement pour :
              </p>
              <ul className="text-[#6B5E50] mt-2 space-y-1.5 ml-4">
                <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 rounded-full bg-[#C9922A] mt-2 flex-shrink-0" /> Répondre à vos demandes de contact et d'information</li>
                <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 rounded-full bg-[#C9922A] mt-2 flex-shrink-0" /> Vous fournir une estimation de revenus locatifs</li>
                <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 rounded-full bg-[#C9922A] mt-2 flex-shrink-0" /> Gérer les réservations de logements</li>
                <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 rounded-full bg-[#C9922A] mt-2 flex-shrink-0" /> Vous envoyer des communications relatives à nos services (avec votre consentement)</li>
              </ul>
            </div>

            <div>
              <h2 className="font-display text-xl text-[#004333] mb-3">Protection des données</h2>
              <p className="text-[#6B5E50] leading-relaxed">
                Nous mettons en oeuvre les mesures techniques et organisationnelles appropriées pour protéger vos données personnelles contre la perte, l'utilisation abusive ou l'accès non autorisé. Vos données sont stockées de manière sécurisée et ne sont accessibles qu'aux personnes habilitées.
              </p>
            </div>

            <div>
              <h2 className="font-display text-xl text-[#004333] mb-3">Durée de conservation</h2>
              <p className="text-[#6B5E50] leading-relaxed">
                Vos données personnelles sont conservées pendant la durée nécessaire à la finalité pour laquelle elles ont été collectées, et au maximum 3 ans après le dernier contact.
              </p>
            </div>

            <div>
              <h2 className="font-display text-xl text-[#004333] mb-3">Vos droits</h2>
              <p className="text-[#6B5E50] leading-relaxed">
                Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez des droits suivants :
              </p>
              <ul className="text-[#6B5E50] mt-2 space-y-1.5 ml-4">
                <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 rounded-full bg-[#C9922A] mt-2 flex-shrink-0" /> Droit d'accès à vos données personnelles</li>
                <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 rounded-full bg-[#C9922A] mt-2 flex-shrink-0" /> Droit de rectification de vos données</li>
                <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 rounded-full bg-[#C9922A] mt-2 flex-shrink-0" /> Droit à l'effacement de vos données</li>
                <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 rounded-full bg-[#C9922A] mt-2 flex-shrink-0" /> Droit à la limitation du traitement</li>
                <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 rounded-full bg-[#C9922A] mt-2 flex-shrink-0" /> Droit à la portabilité de vos données</li>
              </ul>
              <p className="text-[#6B5E50] mt-3 leading-relaxed">
                Pour exercer ces droits, contactez-nous à : <a href="mailto:contact@happyhouse-conciergerie.fr" className="text-[#C9922A] hover:underline">contact@happyhouse-conciergerie.fr</a>
              </p>
            </div>

            <div>
              <h2 className="font-display text-xl text-[#004333] mb-3">Cookies</h2>
              <p className="text-[#6B5E50] leading-relaxed">
                Ce site utilise des cookies techniques strictement nécessaires à son fonctionnement. Aucun cookie publicitaire ou de suivi n'est utilisé sans votre consentement.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
